import React from "react";

export const Question = (props) => {
  return (
    <>
      <div className="question text-colorWhite text-left py-4 px-3 mt-6 mb-6 font-semibold content-center bg-colorSecondary rounded-xl w-3/5">
        {props.question}
      </div>
      {/* <div className="questionArrow"></div> */}
    </>
  );
};
